import { call, put, takeLatest, takeLeading } from "redux-saga/effects";
import { API } from "../../api";
import {
  SHOPPER_ADD,
  SHOPPER_ADD_FAIL,
  SHOPPER_ADD_SUCCESS,
  SHOPPER_LIST,
  SHOPPER_LIST_FAIL,
  SHOPPER_LIST_SUCCESS,
  PERSONAL_SHOPPER_LIST,
  PERSONAL_SHOPPER_LIST_FAIL,
  PERSONAL_SHOPPER_LIST_SUCCESS,
  SHOPPER_DETAIL,
  SHOPPER_DETAIL_FAIL,
  SHOPPER_DETAIL_SUCCESS,
  SHOPPER_ROLE_LIST,
  SHOPPER_ROLE_LIST_FAIL,
  SHOPPER_ROLE_LIST_SUCCESS,
  SHOPPER_STATUS_CHANGE,
  SHOPPER_STATUS_CHANGE_FAIL,
  SHOPPER_STATUS_CHANGE_SUCCESS,
} from "../../actions/admin/customer-actions";

function* shopperList(action) {
  try {
    const response = yield call(API.shopperList, action.payload);
    yield put({ type: SHOPPER_LIST_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: SHOPPER_LIST_FAIL, payload: { error } });
  }
}

function* shopperStatusChange(action) {
  try {
    const { onSuccess, ...data } = action.payload;
    const response = yield call(API.shopperStatusChange, data);
    if (typeof onSuccess === "function") {
      onSuccess();
    }
    yield put({ type: SHOPPER_STATUS_CHANGE_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: SHOPPER_STATUS_CHANGE_FAIL, payload: { error } });
  }
}

function* shopperAdd(action) {
  try {
    const { onSuccess, onError, ...otherPayload } = action.payload || {};
    const response = yield call(API.shopperCreate, otherPayload);
    if (typeof onSuccess === "function") {
      onSuccess();
    }
    yield put({ type: SHOPPER_ADD_SUCCESS, payload: response.data });
  } catch (error) {
    if (typeof action.payload?.onError === "function") {
      action.payload.onError(error);
    }
    yield put({ type: SHOPPER_ADD_FAIL, payload: { error } });
  }
}

function* shopperRoleList() {
  try {
    const response = yield call(API.shopperRoleList);
    yield put({ type: SHOPPER_ROLE_LIST_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: SHOPPER_ROLE_LIST_FAIL, payload: { error } });
  }
}

function* personalShopperList(action) {
  try {
    const response = yield call(API.personalShopperList, action.payload);
    yield put({ type: PERSONAL_SHOPPER_LIST_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: PERSONAL_SHOPPER_LIST_FAIL, payload: { error } });
  }
}

function* shopperDetail(action) {
  const shopperId = action.payload?.id;
  try {
    const response = yield call(API.personalShopperById, shopperId);
    const body = response?.data;
    const detail = body?.data;
    if (!detail?.id) {
      yield put({
        type: SHOPPER_DETAIL_FAIL,
        payload: { error: { data: { message: "Invalid shopper response" } } },
      });
      return;
    }
    yield put({ type: SHOPPER_DETAIL_SUCCESS, payload: body });
  } catch (error) {
    yield put({ type: SHOPPER_DETAIL_FAIL, payload: { error } });
  }
}

function* shopperSaga() {
  yield takeLatest(PERSONAL_SHOPPER_LIST, personalShopperList);
  yield takeLatest(SHOPPER_DETAIL, shopperDetail);
  yield takeLeading(SHOPPER_ADD, shopperAdd);
  yield takeLatest(SHOPPER_LIST, shopperList);
  yield takeLatest(SHOPPER_ROLE_LIST, shopperRoleList);
  yield takeLatest(SHOPPER_STATUS_CHANGE, shopperStatusChange);
}

export default shopperSaga;
